<template>
  <div class="progress-steps-container"><slot /></div>
</template>

<style lang="scss">
.progress-steps-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: $kds-space-1x;

  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-image: url("data:image/svg+xml,%3Csvg width='2' height='12' viewBox='0 0 2 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='1' y1='0' x2='1' y2='12' stroke='%23C3D5E5' stroke-width='2' stroke-dasharray='6 6'/%3E%3C/svg%3E");
    background-repeat: repeat-y;
  }

  .progress-steps-item {
    &:first-of-type::before {
      content: '';
      position: absolute;
      left: 7px;
      top: 0;
      bottom: 50%;
      width: 2px;
      background-color: white;
      z-index: 1;
    }

    &:last-of-type::after {
      content: '';
      position: absolute;
      left: 7px;
      top: 50%;
      bottom: 0;
      width: 2px;
      background-color: white;
      z-index: 1;
    }
  }
}
</style>
